import styled from 'styled-components';

export const AskQuestionContainer = styled.section`
  width: 100%;
  background: rgb(255, 250, 242);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 120px 0;

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  padding: 0 32px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;

  @media (max-width: 1024px) {
    gap: 60px;
    padding: 0 32px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
    padding: 0 32px;
    text-align: center;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 550px;

  @media (max-width: 1024px) {
    max-width: 500px;
  }

  @media (max-width: 768px) {
    max-width: none;
    align-items: center;
  }
`;

export const Title = styled.h2`
  font-family: 'Sora', 'Mulish', 'Helvetica', sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  color: #1B170C;
  margin: 0;
  letter-spacing: -0.02em;

  @media (max-width: 1024px) {
    font-size: 42px;
  }

  @media (max-width: 768px) {
    font-size: 36px;
    line-height: 1.3;
  }

  @media (max-width: 480px) {
    font-size: 32px;
  }

  @media (max-width: 360px) {
    font-size: 28px;
  }
`;

export const Description = styled.p`
  font-family: 'Sora', 'Mulish', 'Helvetica', sans-serif;
  font-size: 22px;
  font-weight: 400;
  line-height: 1.7;
  color: #393324;
  margin: 0;

  @media (max-width: 1024px) {
    font-size: 20px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 1.8;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

export const PhoneImage = styled.img`
  width: 100%;
  max-width: 484px;
  height: auto;
  object-fit: contain;
  justify-self: center;
  transition: transform 0.4s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 1024px) {
    max-width: 400px;
  }

  @media (max-width: 768px) {
    max-width: 350px;
  }

  @media (max-width: 480px) {
    max-width: 300px;
  }
`;
